export const GET_BRANDS = 'GET_BRANDS';
export const GET_SINGLE_BRAND = 'GET_SINGLE_BRAND';
export const CLEAR_BRAND = 'CLEAR_BRAND';
export const BRAND_INPUT_CHANGE = 'BRAND_INPUT_CHANGE';
export const BRAND_SEARCH = 'BRAND_SEARCH';
export const SEARCH_INPUT = 'SEARCH_INPUT';
export const SET_PAGE = 'SET_PAGE';
